class RequiredError extends Error {
    constructor(inputName, valueName, ...params) {
        super(...params);

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RequiredError);
        }

        this.inputName = inputName;
        this.valueName = valueName;
        this.name = 'RequiredError';
        this.message = `${this.valueName} is required`;
    }
}